<template>
    <el-dialog
        title="分配预约任务"
        width="80%"
        top="5vh"
        :close-on-click-modal="false"
        :visible.sync="allocationDialogVisible"
        :before-close="handleClose"
        class="allocation-dialog"
    >
    <div class="allocation-layout">
        <div class="left-from">
             <el-form
                :model="form"
                :rules="rules"
                label-width="90px"
                class="from"
                ref="ruleForm"
            >
            <el-row>
                <el-col :span="24" class="driver-type">
                        <el-radio-group v-model="radio" @input="driverTpeChange">
                            <el-radio v-model="radio" label="1">司机</el-radio>
                            <el-radio v-model="radio" label="2">直通宝账号</el-radio>
                        </el-radio-group>
                    </el-col>
                    <el-col :span="24" v-if="radio === '1'" key="承运商">
                        <el-form-item label="承运商" prop="carrierName">
                            <advance-dialog
                                disabled
                                v-model="form.carrierName"
                                :params="carrierName"
                                :mValue="form.carrierName"
                                @getAdvanceValue="getSelectCarrierValue"
                            >
                            </advance-dialog>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" v-if="radio === '1'" key="司机">
                        <el-form-item label="司机" prop="driver">
                            <advance-dialog
                                v-model="form.driver"
                                :formData="form"
                                :params="driverLists"
                                :mValue="form.driver"
                                @getAdvanceValue="getSelectValue"
                            >
                            </advance-dialog>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" v-else key="直通宝账号">
                        <el-form-item label="直通宝账号" prop="driverPhone">
                            <el-input
                                v-model="form.driverPhone"
                                placeholder='请输入'
                                maxlength="11"
                                clearable>
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <div class="right-table">
            <allocation-table ref='allocationTable' :taskDataList="taskDataList"></allocation-table>
        </div>
    </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="handleClose">取 消</el-button>
            <el-button type="primary" @click="handleSure">保 存</el-button>
        </span>
    </el-dialog>
</template>
<script>
import advanceDialog from '@/components/lots/otpAdvance';
import { allocationApi } from '../../../../../api/appointmentCenter';
import AllocationTable from './allocationTable/AllocationTable';
import { mapState } from 'vuex';

const validDriverPhone = (rule, value, callback) => {
    if (value === '') {
        callback(new Error('请输入直通宝账号'));
    } else {
        const regExp = /^1[3-9]\d{9}$/;
        if (!regExp.test(value)) {
            callback(new Error('请输入正确的手机号'));
        }
        callback();
    }
};
export default {
    components: { advanceDialog, AllocationTable },
    props: {
        allocationDialogVisible: {
            type: Boolean,
            default: false
        },
        taskDataList: {
            type: Array,
            default () {
                return [];
            }
        }
    },
    data () {
        return {
            radio: '1',
            form: {
                carrierCode: '', // 承运商编码
                carrierName: '', // 承运商名称
                driver: '', // 司机名称
                driverNo: '', // 司机编码
                driverPhone: '',// 司机电话
                sysId: 'OTP'// 操作系统标识，查司机接口用

            },
            carrierName: {
                name: '请选择承运商',
                value: 'carrierName',
                type: 'advance',
                advanceConfig: [
                    { prop: 'supplierNameCn', value: '承运商名称' },
                    { prop: 'supplierCode', value: '承运商编码' }
                ],
                tableConfig: [
                    { prop: 'supplierNameCn', value: '承运商名称' },
                    { prop: 'supplierCode', value: '承运商编码' },
                    { prop: 'transNameListStr', value: '采购渠道' }
                ],
                advanceNotSearch: true,
                queryConditionRequired: true,
                method: 'post',
                advanceUrl: 'srm/supplier/search',
                prefix: '/api-tms/',
                cbParams: [
                    'supplierNameCn#carrierName', 'supplierCode#carrierCode', 'supplierCode#supplierCode'
                ]
            },
            // 司机
            driverLists: {
                method: 'post',
                name: '请输入司机',
                advanceLabel: '司机',
                value: 'driver',
                advanceConfig: [
                    { prop: 'driverName', value: '司机' },
                    { prop: 'driverPhone', value: '电话' },
                    { prop: 'driverCode', value: 'DN编码' },
                    { prop: 'driverIdCard', value: '身份证号' }
                ],
                tableConfig: [
                    { prop: 'driverName', value: '司机' },
                    { prop: 'driverPhone', value: '电话' },
                    { prop: 'driverCode', value: 'DN编码' },
                    { prop: 'driverIdCard', value: '身份证号' }
                ],
                prefix: '/api-srm-web/',
                 advanceUrl: 'basis/supplierDriverInfo/querySupplierDriverInfo',
                cbParams: ['driverName#driver', 'driverPhone', 'driverCode#driverNo'],
                advanceCascade: 'carrierCode,sysId'
            },
            rules: {
                driver: [
                    { required: true, message: '请选择司机', trigger: 'change' }
                ],
                carrierName: [
                    { required: true, message: '请选择承运商', trigger: 'change' }
                ],
                driverPhone: [
                    { required: true, validator: validDriverPhone, trigger: 'blur' }
                ]
            }
        };
    },
    methods: {
        getSelectCarrierValue (data) {
            this.form = {
                ...this.form,
                ...data
            };
            this.form.driver = '';
        },
        getSelectValue (data) {
            this.form = {
                ...this.form,
                ...data
            };
        },
         // 单选框切换
        driverTpeChange () {
            ['driver', 'driverNo', 'driverPhone'].forEach(key => {
                this.form[key] = '';
            });
        },
        handleClose () {
            this.form = {};
            this.$emit('update:allocationDialogVisible', false);
        },
        handleSure () {
            this.$refs.ruleForm.validate(async (valid) => {
                if (valid) {
                    const selectData = this.$refs.allocationTable.selectData;
                    if (!selectData.length) return this.$message.warning('请先勾选数据');
                    const params = {
                        ...this.form,
                        taskNoList: selectData.map(v => v.taskNo)
                    };
                    if (this.radio === '1') {
                        // 如果选择司机，则不传承运商信息
                        delete params.carrierCode;
                        delete params.carrierName;
                    }
                    allocationApi(params).then(res => {
                        if (res && +res.code === 0) {
                            this.$message.success('分配成功');
                            this.$emit('allocationDialogConfirm');
                        }
                    });
                }
            });
        },
        // 剔除不符合分条件的tk单
        tipCheck () {
            let filterData = this.taskDataList.filter(item => (['999', '998', '880'].includes(item.taskStatus)));
            filterData = filterData.map(i => i.taskNo);
            if (filterData.length) {
                this.$message({
                    message: `运输单号：${filterData.join('、')}，\n共${filterData.length}单，不符合分配条件，无需分配，已自动剔除`,
                    type: 'warning',
                    customClass: 'max-zindex'
                });
            }
        }
    },
    mounted () {
        this.form.carrierCode = this.supplier.supplierCode
        this.form.carrierName = this.taskDataList[0].carrierName || this.taskDataList[0].assignCarrierName
        this.tipCheck();
    },
    computed: {
        ...mapState({
            supplier: state => state.supplier
        }),
    }
};
</script>
<style lang="less">
.allocation-dialog {
    .allocation-layout{
        display: flex;
        .left-from{
            width: 300px;
            margin-right: 10px;
        }
        .right-table{
           flex: 1;
           overflow: hidden;
        }
    }
    .el-date-editor--datetimerange.el-input__inner,
    .el-select {
        width: 100%;
    }
    .from {
        .el-form-item__content .el-input-group {
            vertical-align: middle;
        }
        .el-form-item__label,
        .el-form-item__content {
            line-height: 40px;
        }
        .el-form-item {
            margin-bottom: 14px;
        }
        .driver-type{
            margin-left: 70px;
            margin-bottom: 20px;
        }
        .el-dialog__footer {
            padding: 0px 20px;
            padding-bottom: 10px;
            text-align: right;
            -webkit-box-sizing: border-box;
            box-sizing: border-box;
        }
    }
}
</style>
